/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Toc_TitleInputs */

const en_blog_toc_title = /** @type {(inputs: Blog_Toc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In this article`)
};

const lv_blog_toc_title = /** @type {(inputs: Blog_Toc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šajā rakstā`)
};

/**
* | output |
* | --- |
* | "In this article" |
*
* @param {Blog_Toc_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_toc_title = /** @type {((inputs?: Blog_Toc_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Toc_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_toc_title(inputs)
	return en_blog_toc_title(inputs)
});